import { render, staticRenderFns } from "./MobileShopHome.vue?vue&type=template&id=6fe5d44d"
import script from "./MobileShopHome.vue?vue&type=script&lang=js"
export * from "./MobileShopHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fe5d44d')) {
      api.createRecord('6fe5d44d', component.options)
    } else {
      api.reload('6fe5d44d', component.options)
    }
    module.hot.accept("./MobileShopHome.vue?vue&type=template&id=6fe5d44d", function () {
      api.rerender('6fe5d44d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/MobileShopHome.vue"
export default component.exports